import { AuthProvider } from '@/services/auth';
import { OfflineProvider } from '@/contexts/OfflineContext';
import { AuthGate } from '@/components/layout/AuthGate';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <OfflineProvider>
      <AuthProvider>
        <AuthGate>
          {children}
        </AuthGate>
      </AuthProvider>
    </OfflineProvider>
  );
}
